import axios from 'axios'
import { FC, useEffect, useState } from 'react'

import { setCookie } from 'utils/cookie'
import { useStoreState, useStoreActions } from 'store'
import { rollbar } from 'utils/rollbar'

interface Props {
  isTableRow?: boolean
}

const EmailCapture: FC<Props> = ({ isTableRow = false }) => {
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [processing, setProcessing] = useState(false)
  const zipCode = useStoreState(state => state.location.location.zipcode)
  const { onEmailFormTracking, onClickTracking } = useStoreActions(state => state.tracking)

  const { emailFormConfig } = useStoreState(state => state.emailCapture)
  const increment = useStoreActions(actions => actions.datadog.increment)

  useEffect(() => {
    onEmailFormTracking({ eventName: 'FormStarted' })
  }, [onEmailFormTracking])

  useEffect(() => {
    if (!isTableRow) {
      increment({ name: 'noCoverage', value: 1 })
    }
  }, [increment, isTableRow])

  const onSubmit = async (email: string, hasError: boolean) => {
    if (!hasError && email.length) {
      const { location } = emailFormConfig

      setCookie('email', email)
      onEmailFormTracking({ eventName: 'FormSubmitted' })
      onClickTracking({
        element: {
          type: 'button',
          location,
          position: '',
          htmlId: '',
          text: '',
          name: 'Bankrate Mortgage Email Capture',
        },
        outcome: 'success',
        additionalSkipLowerCase: ['location'],
      })

      let anonymousId = 'fake-anonymous-id'

      if (process.env.REACT_APP_ENV === 'production') {
        try {
          anonymousId = globalThis._Tagular.webContext.anonymousId
        } catch (err) {
          console.log('unable to extract anonymous id -- email capture was not sent')
          return
        }
      }

      setProcessing(true)

      let userId
      try {
        const response = await axios.post(`${process.env.REACT_APP_MORTGAGE_API_URL}/coverage-email-signup?pid=br3`, {
          email: email,
          zipCode,
          location,
          eventName: 'mortgage_rate_alerts_instant_event',
          anonymousId,
        })
        userId = response.data.userId
      } catch (err: any) {
        if (err.response) {
          rollbar.error(`email signup request ${err.response.status} error`, err.response.data)
        }
      }

      setProcessing(false)

      if (userId) {
        setIsSuccessful(true)
        const authenticatedContext = {
          userId,
          appTenantId: 'bankrate',
        }
        onEmailFormTracking({
          eventName: 'FormOutcomeReceived',
          stepName: 'Verify_Identity_Emailonly',
          authenticatedContext,
        })
      }
    }
  }

  return emailFormConfig ? (
    <emailFormConfig.Component {...{ onSubmit, setIsSuccessful, isSuccessful, processing }} />
  ) : null
}

export default EmailCapture
